import { QuestionBase } from '../question-base';

export class DatepickerQuestion extends QuestionBase<string> {
  controlType = 'datepicker';
}